var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getFormattedDateWithoutTimeZone } from 'common/helpers/get-formatted-date';
import { getFormattedPhone } from 'common/helpers/get-formatted-phone';
import { getSupervisorInfo } from 'common/helpers/get-supervisor-info';
export var profileServiceDataSelector = function (state) { return state && state.content; };
export var profileServiceAvailablePagesSelector = function (state) {
    return state.content && state.content.availableFeatures;
};
export var profileServiceMainDataSelector = function (_a) {
    var content = _a.content;
    return content
        ? {
            id: content.id,
            firstName: content.firstName,
            lastName: content.lastName,
            fullName: content.fullName,
            middleName: content.middleName,
            personnelNumber: content.personnelNumber,
            image: content.image,
            tealBalance: content.tealBalance,
            supervisorBalance: content.supervisorBalance,
            thankBalance: content.thankBalance,
            isSystemInternal: content.isSystemInternal,
            email: content.email,
            position: content.position,
        }
        : {
            id: '',
            firstName: '',
            lastName: '',
            middleName: '',
            personnelNumber: '',
            fullName: '',
            image: null,
            tealBalance: 0,
            thankBalance: 0,
            supervisorBalance: 0,
            email: '',
            isSystemInternal: false,
            position: null,
        };
};
export var profileServiceSecondaryDataSelector = function (_a) {
    var content = _a.content;
    return content
        ? {
            tags: __spreadArray(__spreadArray([], content.customTags, true), content.importedTags, true),
            city: content.city,
            about: content.about,
            department: content.department,
            hireDate: content.hireDate && getFormattedDateWithoutTimeZone(content.hireDate, 'P'),
            birthDate: content.birthDate && getFormattedDateWithoutTimeZone(content.birthDate, 'd MMMM'),
            probationEndDate: content.probationEndDate && getFormattedDateWithoutTimeZone(content.probationEndDate, 'P'),
            fireDate: content.fireDate && getFormattedDateWithoutTimeZone(content.fireDate, 'P'),
            phone: content.phone && getFormattedPhone(content.phone),
            email: content.email,
            position: content.position,
            socialNetworks: content.socialNetworks,
            supervisor: content.supervisor && getSupervisorInfo(content.supervisor),
            peopleManager: content.peopleManager && getSupervisorInfo(content.peopleManager),
            peopleManagerDelegate: content.peopleManagerDelegate && getSupervisorInfo(content.peopleManagerDelegate),
        }
        : null;
};
export var profileServiceEmailSelector = function (_a) {
    var _b;
    var content = _a.content;
    return (_b = content === null || content === void 0 ? void 0 : content.email) !== null && _b !== void 0 ? _b : '';
};
export var profileServiceUserIdSelector = function (state) { var _a; return ((_a = state.content) === null || _a === void 0 ? void 0 : _a.id) || null; };
export var profileServiceIsAuthSelector = function (state) { var _a; return Boolean((_a = state.content) === null || _a === void 0 ? void 0 : _a.id); };
export var profileServiceLoadingSelector = function (state) { return Boolean(state.loading); };
export var profileServiceInitializedSelector = function (state) { return Boolean(state.initialized); };
export var profileServiceIsAgreeWithUsagePoliciesSelector = function (state) { var _a; return Boolean((_a = state.content) === null || _a === void 0 ? void 0 : _a.isAgreeWithUsagePolicies); };
export var profileServiceIdSelector = function (state) { var _a; return ((_a = state.content) === null || _a === void 0 ? void 0 : _a.id) || ''; };
export var profileServiceCompanyIdSelector = function (state) { var _a; return ((_a = state.content) === null || _a === void 0 ? void 0 : _a.company.id) || ''; };
export var profileServiceIsUseTechSelector = function (state) { var _a; return Boolean(((_a = state.content) === null || _a === void 0 ? void 0 : _a.company.id) === 'b9f28dcc-ff5e-456f-9266-031e54ae670a'); }; // USETECH company id
export var profileServiceCompanyNameSelector = function (state) { var _a; return ((_a = state.content) === null || _a === void 0 ? void 0 : _a.company.name) || ''; };
export var profileServiceCompanyCultureSelector = function (state) { var _a; return ((_a = state.content) === null || _a === void 0 ? void 0 : _a.company.culture.localizationKey) || ''; };
